import type { ChangeEvent, DragEvent, ReactNode } from "react";
import { motion } from "framer-motion";

interface UploadDropZoneProps {
  dragOver: boolean;
  uploading: boolean;
  handleDragOver: (event: DragEvent) => void;
  handleDragLeave: () => void;
  handleDrop: (event: DragEvent) => Promise<void>;
  handleFileChange: (event: ChangeEvent<HTMLInputElement>) => Promise<void>;
}

/** The OFX drop zone and its hidden file input. */
export function UploadDropZone({
  dragOver,
  uploading,
  handleDragOver,
  handleDragLeave,
  handleDrop,
  handleFileChange,
}: UploadDropZoneProps): ReactNode {
  return (
    <motion.label
      className={`upload-zone${dragOver ? " drag-over" : ""}`}
      whileHover={{ scale: 1.005 }}
      whileTap={{ scale: 0.995 }}
      onDragOver={handleDragOver}
      onDragLeave={handleDragLeave}
      onDrop={(e) => void handleDrop(e as unknown as DragEvent)}
    >
      <div className="upload-icon" aria-hidden="true">
        <svg
          width="40"
          height="40"
          viewBox="0 0 40 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M20 26V10M20 10L14 16M20 10L26 16"
            stroke="currentColor"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M6 22V30C6 31.1046 6.89543 32 8 32H32C33.1046 32 34 31.1046 34 30V22"
            stroke="currentColor"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>
      <span className="upload-text">Drop your OFX file here or click to browse</span>
      <span className="upload-hint">Upload bank statement (.ofx / .qfx)</span>
      <input
        type="file"
        accept=".ofx,.qfx"
        onChange={(e) => void handleFileChange(e)}
        disabled={uploading}
        style={{ display: "none" }}
      />
    </motion.label>
  );
}
